export const CyPlaylistIndexTable = {
  PlaylistSummary: "PlaylistSummary",
} as const;
